import { formatDate, reverseDateString } from 'features/order-tracker/utils';
import { AVAILABLE_SLOTS_TYPES } from '../utils/entries';

import {
  MAX_DAYS_NUMBER_FOR_AMPM_SLOTS,
  MAX_DAYS_NUMBER_FOR_MIXED_SLOTS,
  MAX_DAYS_NUMBER_FOR_TWOHOURS_SLOTS,
  mapSlotsPropertiesBySlotsType,
  mapSlotsValueBySlotsName,
  slotAMPMProperties,
  slotTwoHoursAltProperties,
  slotTwoHoursProperties,
} from './constants';

class AmendPreAppointmentService {
  normalizeAppointments = (
    availableAppointments: api.PreAppointmentModel[],
    requestedDate: string,
    isInitRequest?: boolean,
  ): common.PreAppointmentData => {
    const slotsType = this.getSlotsType(availableAppointments);
    const formattedDate = reverseDateString(requestedDate, '-');
    const daysLimit =
      (slotsType === 'AM/PM' && MAX_DAYS_NUMBER_FOR_AMPM_SLOTS) ||
      (slotsType === 'TwoHourMix' && MAX_DAYS_NUMBER_FOR_MIXED_SLOTS) ||
      MAX_DAYS_NUMBER_FOR_TWOHOURS_SLOTS;

    const normalizedAvailableAppointments: common.PreAppointment[] = availableAppointments.map((appointment) => {
      const [day, month] = appointment.Date.split('/');

      return {
        dateInfo: appointment.DateInfo,
        formattedDate: `${appointment.DayOfWeek} ${+day} ${month.trim()}`,
        availableSlots: this.formatAvailableSlots(appointment, slotsType),
      };
    });

    let indexOfRequestedDateInfo = isInitRequest ? 0 : normalizedAvailableAppointments.reduce<number | null>(
      (reqDateIdx, appointment, index) => {
        if (appointment.dateInfo.startsWith(formattedDate)) {
          return index;
        }
        return reqDateIdx;
      },
      null,
    );

    if (indexOfRequestedDateInfo === null) {
      indexOfRequestedDateInfo = 0;
      normalizedAvailableAppointments.unshift({
        dateInfo: formattedDate,
        formattedDate: formatDate('dddd DD MMMM', formattedDate),
        availableSlots: [],
      });
    }

    return {
      preAppointments: normalizedAvailableAppointments.slice(
        Number(indexOfRequestedDateInfo),
        Number(indexOfRequestedDateInfo) + daysLimit,
      ),
      slotsType,
    };
  };

  private formatAvailableSlots = (
    appointment: api.PreAppointmentModel,
    slotsType: common.AvailableSlotsType,
  ): string[] =>
    mapSlotsPropertiesBySlotsType[slotsType].reduce<string[]>(
      (slots, property) => (appointment[property] ? [...slots, mapSlotsValueBySlotsName[property]] : slots),
      [],
    );

  private getSlotsType = (appointments: api.PreAppointmentModel[]): common.AvailableSlotsType => {
    const [hasAMPMSlots, hasTwoHoursSlots, hasTwoHoursAltSlots] = appointments.reduce<boolean[]>(
      (result, appointment) => [
        result[0] || slotAMPMProperties.some((property) => appointment[property]),
        result[1] || slotTwoHoursProperties.some((property) => appointment[property]),
        result[2] || slotTwoHoursAltProperties.some((property) => appointment[property]),
      ],
      [],
    );

    return (
      (hasAMPMSlots && AVAILABLE_SLOTS_TYPES.HalfDay) ||
      (hasTwoHoursSlots && hasTwoHoursAltSlots && AVAILABLE_SLOTS_TYPES.TwoHourMix) ||
      (hasTwoHoursAltSlots && AVAILABLE_SLOTS_TYPES.TwoHourAlt) ||
      AVAILABLE_SLOTS_TYPES.TwoHour
    );
  };
}

const amendPreAppointmentService = new AmendPreAppointmentService();
export { amendPreAppointmentService };
